import React, {useState, useEffect} from 'react'
import cn from "classnames"
import pageBg from  '../../img/waterfall-page-bg.webp'
import modalBg from '../../img/waterfall-modal-bg.svg'
import contentImg1 from '../../img/waterfall-img1.webp'
import {Preloader, SpriteSvg} from '../../components'
import videBg from "../../img/waterfall-video.mp4";
import ReactPlayer from "react-player";

const WaterfallPage = ({
	handleNextPage,
	name,
	isLoaded,
	setIsLoaded,
	isRouteTraveled,
	setIsRouteTraveled,
	waterfallPage,
	afterWaterfallGamePage,
}) => {

const [isVisibleContent, setIsVisibleContent] = useState(false)
const [isVisiblePage, setIsVisiblePage] = useState(true)
	const [isVisibleGame, setIsVisibleGame] = useState(false)
const [modalContentChange, setModalContentChange] = useState(false)

	useEffect(()=> {
		window.TN_REACTION.run("#area");
		setTimeout(()=> {
			setIsVisibleContent(true)
		},7000)
	},[])

	const handleMeadowGame = () => {
		setIsVisiblePage(false)
		setIsVisibleGame(true)
		window.TN_REACTION.showStartMessage()
		window.TN_REACTION.successCallback = () => {
			setIsRouteTraveled([...isRouteTraveled, waterfallPage])
			setIsVisibleGame(false)
			handleNextPage(afterWaterfallGamePage)
		}
	}

	return (
		<>
		<Preloader isLoaded={isLoaded} setIsLoaded={setIsLoaded}/>
			<div id='area' className={cn(
				'game-wrap',
				isVisibleGame && 'active'
			)}></div>

			{isVisiblePage &&
		<div className={cn(
					 'full-page',
					 'waterfall-page',
					 isLoaded && 'active'
				 )}
		>
			<div className="page-bg">
				<ReactPlayer
					className='video-bg'
					width='100%'
					height='100%'
					url={videBg}
					muted={true}
					controls={false}
					playsinline
					loop
					playing
				/>
				<img className='bg-img' src={pageBg} alt=""/>
			</div>

			<div className={cn(
						 'page-content',
						 isVisibleContent &&
						 'active'
					 )}>

				<div className={cn(
							 'modal',
					modalContentChange &&
					'disabled'
						 )}
				>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>


					<div className={cn(
						'modal-content'
					)}
					>
						<div className="text">
							<p className='mg-b-8'>Теперь в рюкзаке только самое необходимое.</p>
							<p className='mg-b-8'>Однако, я заметил, что кое-чего не хватает.</p>
							<p className='mg-b-8'>Вот, например, как покорять пик с пустой флягой?</p>
							<p className='mg-b-8'>К счастью, я предусмотрительно провёл нас мимо водопада, а тут ещё такие девушки!</p>
							<p className='mg-b-8'>Вода здесь живительная, но её нужно очистить, иначе хруст песка на зубах будет слышен на самом верху!</p>
							<p className='mg-b-8'>Благо, девушки знают секрет, как добыть чистую воду. И не медли, у нас не так много времени!</p>

						</div>

						<div className="btn-wrap jcfs">
							<div onClick={()=> handleMeadowGame()} className="btn green" style={{width: '190px'}}>
								<SpriteSvg id='train-station-page-btn-green-bg'/>
								<span>Добыть воду</span>
							</div>
						</div>
					</div>

				</div>

				<div className={cn(
					'content',
					'center',
				)}>
					<div className="img-wrap">
						<img src={contentImg1} alt=""/>
					</div>

				</div>

			</div>

		</div>
			}
		</>
	)
}

export default WaterfallPage